import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OpnSupplierListSaveModel } from '.';

const localApiUrl = `${environment.apiUrl}/RequestOpnSupplierList`;

@Injectable()
export class OpnSupplierListService {

  constructor(private http: HttpClient) { }

  delete(id: number): Promise<void> {
      return this.http.post<void>(`${localApiUrl}/Delete`,id).toPromise();
  }

  save(model: OpnSupplierListSaveModel): Promise<void> {
      return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }
}
